<app-hero [config]="heroConfig"></app-hero>
<app-content></app-content>
<app-contact-form [config]="CEO_CONFIG"></app-contact-form>
